import Button from '../../../../../../../common/components/Button';
import glamorous from 'glamorous';

const animationStyle = {
  transform: 'translateY(-100px)',
  transition: 'opacity .3s, visibility .3s, transform .4s, height .5s, margin .5s',
  opacity: 0,
  visibility: 'hidden',
  height: 0,
  margin: 0,
};

const visibleStyle = {
  opacity: 1,
  visibility: 'visible',
  transform: 'translateY(0)',
  height: 'auto',
};

export const IdentificationForm = glamorous.form({
  margin: 'auto',
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2em 1.6rem',
  textAlign: 'center',
  '& div': { width: '100%' },
});

export const ConfirmText = glamorous.p(
  {
    ...animationStyle,
    margin: '1em 0 !important',
  },
  ({ isConfirming }) => {
    return isConfirming ? { ...visibleStyle } : {};
  }
);

export const ConfirmButton = glamorous(Button, {
  rootEl: 'button',
  forwardProps: Object.keys(Button.propTypes),
})(
  {
    ...animationStyle,
  },
  ({ isConfirming }) => {
    return isConfirming ? { ...visibleStyle } : {};
  }
);

export const SubmitButton = glamorous(Button, {
  rootEl: 'button',
  forwardProps: Object.keys(Button.propTypes),
})(
  {
    ...animationStyle,
  },
  ({ isConfirming }) => {
    return isConfirming ? {} : { ...visibleStyle };
  }
);



// WEBPACK FOOTER //
// ./src/App/events/Views/Detail/RegistrationCard/Availability/UserIdentification/styles.js